import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service/common-service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  plantCode = "";
  securityGroup: boolean;
  constructor(commonService: CommonService, public spinner: NgxSpinnerService) {
    this.securityGroup = commonService.getSecurityGroup();
  }

  ngOnInit(): void {
    this.plantCode = localStorage.getItem('plantCode')
  }

  download() {
    this.spinner.show()
    const url = '../../assets/Responsibilities for Lithium Battery.pdf'
    FileSaver.saveAs(url, 'Lithium Battery Check List');
    this.spinner.hide()
  }
}


